import {useEffect} from 'react'

/**
 * @return {null}
 */
function LogoutPage({...props}) {

  useEffect(() => {
    const token = localStorage.getItem('jwt-token')
    // logout front
    localStorage.removeItem('jwt-token')
    // trigger single logout
    window.location.assign(`/auth/logout?token=${token}`)

  })

  return null
}

export default LogoutPage
